import styled from 'styled-components';
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import { useBack } from '../hooks/useBack';
import SlideList from '../components/molecules/common/SlideList';
import Indicator from '../components/molecules/common/Indicator';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { tutorialImages } from '../data/tutorialImages';
import { tutorialUrlMaps } from '../data/tutorialConfig';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const CarouselFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  height: 8px;
`
const TutorialDetail = () => {
  const { type } = useParams();
  const dataKey = tutorialUrlMaps[type];
  const datas = tutorialImages[dataKey].steps;
  const title = tutorialImages[dataKey].title;

  const goBack = useBack(); // 뒤로가기 훅 호출
  
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <DefaultLayout
      headerType="sub" 
      onBack={goBack}
      title={title}>
      <Wrapper>
        <SlideList 
          datas={datas}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
        />
        <CarouselFooter>
          <Indicator
            len={datas.length}
            currentIndex={currentIndex}
            onClick={setCurrentIndex}
          />
        </CarouselFooter>
      </Wrapper>
    </DefaultLayout>
  )
}

export default TutorialDetail
